import { useMerchantList } from "@HOOKS";
const useLogics = () => {
  const merchants = useMerchantList();
  const columns = [
    {
      title: "Barkod",
      key: "barcode",
      dataIndex: "barcode",
      width: 250,
      fixed: true,
    },
    {
      title: "Müşteri Sipariş Numarası",
      key: "customer_order_id",
      dataIndex: "customer_order_id",
      width: 250,
      fixed: true,
    },
    {
      title: "Kabul Tarihi",
      key: "accept_date",
      dataIndex: "accept_date",
      width: 200,
    },
    {
      title: "Müşteri Adı",
      key: "company_name",
      dataIndex: "company_name",
      width: 200,
    },
    merchants.length > 1
      ? {
          title: "Merchant Adı",
          key: "merchant_name",
          dataIndex: "merchant_name",
          width: 200,
        }
      : undefined,
    {
      title: "Gönderen Müşteri Adresi",
      key: "sender_address",
      dataIndex: "sender_address",
      width: 200,
    },
    {
      title: "Alıcı Müşteri",
      key: "receiver",
      dataIndex: "receiver",
      width: 200,
    },
    {
      title: "Alıcı Müşteri Adresi",
      key: "receiver_address",
      dataIndex: "receiver_address",
      width: 200,
    },
    {
      title: "Alıcı Müşteri Telefon Numarası",
      key: "receiver_phone",
      dataIndex: "receiver_phone",
      width: 200,
    },
    {
      title: "Çıkış İli",
      key: "out_city",
      dataIndex: "out_city",
      width: 200,
    },
    {
      title: "Çıkış Tarihi",
      key: "out_date",
      dataIndex: "out_date",
      width: 200,
    },
    {
      title: "Çıkış Birimi",
      key: "out_xdock",
      dataIndex: "out_xdock",
      width: 200,
    },
    {
      title: "Varış Birimi",
      key: "in_xdock",
      dataIndex: "in_xdock",
      width: 200,
    },
    {
      title: "Varış İli",
      key: "in_city",
      dataIndex: "in_city",
      width: 200,
    },
    {
      title: "Teslim İli",
      key: "delivery_city",
      dataIndex: "delivery_city",
      width: 200,
    },
    {
      title: "Teslim İlçesi",
      key: "delivery_town",
      dataIndex: "delivery_town",
      width: 200,
    },
    {
      title: "Ürün Adı",
      key: "product_name",
      dataIndex: "product_name",
      width: 200,
    },
    {
      title: "Servis Tipi",
      key: "service_name",
      dataIndex: "service_name",
      width: 200,
    },
    {
      title: "Özel Kod",
      key: "special_tag_name",
      dataIndex: "special_tag_name",
      width: 200,
    },

    {
      title: "Toplam Kargo Adedi",
      key: "total_parcels",
      dataIndex: "total_parcels",
      width: 200,
    },
    {
      title: "Desi/KG",
      key: "desi",
      dataIndex: "desi",
      width: 200,
    },
    {
      title: "İrsaliye Numarası",
      key: "customer_delivery_no",
      dataIndex: "customer_delivery_no",
      width: 200,
    },
    {
      title: "Teslim Alan",
      key: "delivered_person",
      dataIndex: "delivered_person",
      width: 200,
    },
    {
      title: "Teslim Alan Depo Sorumlusu",
      key: "responsible_person",
      dataIndex: "responsible_person",
      width: 200,
    },
    // {
    //   title: 'İade Kabul Tarihi',
    //   key: 'returned_delivered_date',
    //   dataIndex: 'returned_delivered_date',
    //   width: 200,
    // },
    {
      title: "Teslim Tarihi",
      key: "delivered_date",
      dataIndex: "delivered_date",
      width: 200,
    },
    {
      title: "Gönderi Statüsü",
      key: "translation_tr",
      dataIndex: "translation_tr",
      width: 200,
    },
    {
      title: "Gönderi Lokasyonu",
      key: "location_tr",
      dataIndex: "location_tr",
      width: 200,
    },
    {
      title: "Oluşturulma Tarihi",
      key: "created_on",
      dataIndex: "created_on",
      width: 200,
    },
    {
      title: "Söz Verilen Tarih",
      key: "delivery_date_promised",
      dataIndex: "delivery_date_promised",
      width: 200,
    },
    {
      title: "İlk Uğrama Tarihi",
      key: "first_visit_time",
      dataIndex: "first_visit_time",
      width: 200,
    },
    {
      title: "Uğrama Sayısı",
      key: "delivery_attempt",
      dataIndex: "delivery_attempt",
      width: 200,
    },
    {
      title: "Teslim Edilmeme Sebebi",
      key: "sebep",
      dataIndex: "sebep",
      width: 200,
    },
    {
      title: "Teslim Zamanı",
      key: "teslim_zamani",
      dataIndex: "teslim_zamani",
      width: 200,
    },
    {
      title: "Paket Sayısı",
      key: "total_parcels",
      dataIndex: "total_parcels",
      width: 200,
    },
  ].filter(Boolean);

  const excelColumns = [
    {
      title: "Barkod",
      key: "barcode",
    },
    {
      title: "Müşteri Sipariş Numarası",
      key: "customer_order_id",
    },
    {
      title: "Kabul Tarihi",
      key: "accept_date",
    },
    {
      title: "Müşteri Adı",
      key: "company_name",
    },
    merchants.length > 0
      ? {
          title: "Merchant Adı",
          key: "merchant_name",
        }
      : undefined,
    {
      title: "Gönderen Müşteri Adresi",
      key: "sender_address",
    },
    {
      title: "Alıcı Müşteri",
      key: "receiver",
    },
    {
      title: "Alıcı Müşteri Adresi",
      key: "receiver_address",
    },
    {
      title: "Alıcı Müşteri Telefon Numarası",
      key: "receiver_phone",
    },
    {
      title: "Çıkış İli",
      key: "out_city",
    },
    {
      title: "Çıkış Tarihi",
      key: "out_date",
    },
    {
      title: "Çıkış Birimi",
      key: "out_xdock",
    },
    {
      title: "Varış Birimi",
      key: "in_xdock",
    },
    {
      title: "Varış İli",
      key: "in_city",
    },
    {
      title: "Teslim İli",
      key: "delivery_city",
    },
    {
      title: "Teslim İlçesi",
      key: "delivery_town",
    },
    {
      title: "Ürün Adı",
      key: "product_name",
    },
    {
      title: "Servis Tipi",
      key: "service_name",
    },
    {
      title: "Özel Kod",
      key: "special_tag_name",
    },
    {
      title: "Toplam Kargo Adedi",
      key: "total_parcels",
    },
    {
      title: "Desi/KG",
      key: "desi",
    },
    {
      title: "İrsaliye Numarası",
      key: "customer_delivery_no",
    },
    {
      title: "Teslim Alan",
      key: "delivered_person",
    },
    {
      title: "Teslim Alan Depo Sorumlusu",
      key: "responsible_person",
    },
    // {
    //   title: "İade Kabul Tarihi",
    //   key: "returned_delivered_date",
    // },
    {
      title: "Teslim Tarihi",
      key: "delivered_date",
    },
    {
      title: "Gönderi Statüsü",
      key: "translation_tr",
    },
    {
      title: "Gönderi Lokasyonu",
      key: "location_tr",
    },
    {
      title: "Oluşturulma Tarihi",
      key: "created_on",
    },
    {
      title: "Söz Verilen Tarih",
      key: "delivery_date_promised",
    },
    {
      title: "İlk Uğrama Tarihi",
      key: "first_visit_time",
    },
    {
      title: "Uğrama Sayısı",
      key: "delivery_attempt",
    },
    {
      title: "Teslim Edilmeme Sebebi",
      key: "sebep",
    },
    {
      title: "Teslim Zamanı",
      key: "teslim_zamani",
    },
    {
      title: "Paket Sayısı",
      key: "total_parcels",
    },
  ].filter(Boolean);
  const searchKeys = [];
  return { columns, excelColumns, searchKeys };
};

export default useLogics;
